import React from "react"
import { Button, buttonClasses, ButtonProps } from "@mui/base/Button"
import { styled } from "@mui/material"

const ButtonComponent = ({ ...restProps }: ButtonProps) => {
  return <Btn {...restProps} />
}

export default ButtonComponent

const Btn = styled(Button)`
  border-radius: 21px;
  border: none;
  cursor: pointer;
  height: 44px;
  max-width: 376px;
  padding: 0 20px;
  text-align: center;
  transition: all 150ms ease;
  width: 100%;

  &.${buttonClasses.root} {
  }

  &.${buttonClasses.active} {
    opacity: 0.8;
  }

  &.${buttonClasses.focusVisible} {
    outline: none;
  }

  &.${buttonClasses.disabled} {
    cursor: not-allowed;
    opacity: 0.2;
    pointer-events: none;
  }
`
